import React from 'react';
import { Trans } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { isReferralBonusActive } from '../../../views/Pages/Root/Referral/PromoConfig';
import styles from './DetailedModal.styles';

const useStyles = createUseStyles(styles);

export default function DetailedModal() {
  const classes = useStyles();

  if (isReferralBonusActive) {
    return (
      <>
        <div className={classes.contentMini}>
          <h3 className={classes.paragraphHeader}>
            <Trans>How it works</Trans>
          </h3>
          <p className={classes.paragraph}>
            <Trans>
              Refer your friends and get rewarded! When they sign up, complete
              KYC, and invest at least $500 for 60 days, both of you will receive
              <strong> $10 in DFI</strong>, automatically staked and earning
              rewards.
            </Trans>
          </p>
          <p className={classes.paragraph}>
            <Trans>
              There's no limit to how many friends you can invite - the more, the
              merrier!
            </Trans>
          </p>
          <p className={classes.lastParagraph}>
            <Trans>
              Bonuses are locked for 6 months and paid out in DFI, so you can grow
              your crypto passively.
            </Trans>
          </p>
          <p className={classes.lastParagraph}>
            <Trans>
              Got questions? Check out our{' '}
              <a
                href="https://support.bake.io/en/articles/11090467-referral-promo"
                target="_blank"
                rel="noopener noreferrer"
              >
                FAQ
              </a>{' '}
              for all the details.
            </Trans>
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className={classes.contentMini}>
        <h3 className={classes.paragraphHeader}>
          <Trans>WELCOME BONUS</Trans>
        </h3>
        <p className={classes.paragraph} style={{ marginBottom: 8 }}>
          <Trans>Receive US$30 worth of bonus in DFI upon completion of the steps below:</Trans>
        </p>
        <ol>
          <li>
            <Trans>
              Deposit at least US$50 into your Bake account. It doesn’t matter which coin you use, as long as the minimum amount is at least US$50.
            </Trans>
          </li>
          <li>
            <Trans>
              Next, allocate at least US$50 into Staking or Liquidity Mining.
            </Trans>
          </li>
          <li>
            <Trans>
              Minimum vesting period: In case you use our Staking or Liquidity Mining product, then you also have to allocate the Staking or Liquidity Mining shares into our Freezer. The minimum tenure is 1 month.
            </Trans>
          </li>
          <li>
            <Trans>And that's it, you're all set.</Trans>
          </li>
        </ol>

        <p className={classes.lastParagraph}>
          <Trans>
            Upon doing so, the above mentioned DFI bonus will be automatically credited to your account and be locked in our Freezer for 180 days.
            It will generate staking rewards during this period and while remaining locked in the Freezer.
          </Trans>
        </p>
      </div>
    </>
  );
}
